import { ContentManagerModule } from '@2sic.com/sxc-angular';
import { Component, computed, inject, input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { Categories, DownloadCategory, LegacyDrivers } from '../downloadsModel';
import { ToolbarHelperService } from '../toolbar-helper.service';

@Component({
  selector: 'app-legacy-driver',
  imports: [ContentManagerModule, MatExpansionModule],
  templateUrl: './legacy-driver.component.html',
  styleUrl: './legacy-driver.component.scss',
})
export class LegacyDriverComponent {
  toolbarHelperSvc = inject(ToolbarHelperService);

  downloadCategory = DownloadCategory;

  items = input.required<LegacyDrivers[]>();
  categoryInfo = input.required<Categories>();
  title = input.required<string>();
  showNew = input<boolean>(false);

  sortedItems = computed(() => {
    return [...this.items()].sort((a, b) => a.Title.localeCompare(b.Title));
  });


}
